import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokSpacingType } from '../../model/storyblokTypes.generated'

export const StoryblokSpacing: FC<
  StoryblokComponentProps<StoryblokSpacingType>
> = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx(
        blok.spacing === 'sm' && 'size-2',
        blok.spacing === 'md' && 'size-4',
        blok.spacing === 'lg' && 'size-6',
      )}
    />
  )
}
